import toggle from './nav-toggle.js';
import './tabbing-navigation.js';
import './sticky.js';
import SubmenuNavigation from './submenu-navigation.js';
import PageAnchorObserver from './page-anchor-observer.js';
import GroupColorChange from './group-color-change.js';

import '../sass/style.scss';

( function( $ ) {

    $( document ).ready( function() {

        $( 'body' ).removeClass( 'no-js' );

        let navToggle = new toggle();
        navToggle.init();

        let subNav = new SubmenuNavigation();
        subNav.init();

        let pageAnchorObserver = new PageAnchorObserver();
        pageAnchorObserver.init();

        let groupColorChange = new GroupColorChange();
        groupColorChange.init();

        $( document ).on( 'click', 'a[href^="#"]', function(event) {
            event.preventDefault();

            // Get the current target hash
            var target = this.hash;

            if ( ! target || ! $( target ).length ) {
                return;
            }

            // Animate the scroll bar action so its smooth instead of a hard jump
            $('html, body').stop().animate({
                'scrollTop' : $(target).offset().top - 120 + 'px'
            }, 300 );

        });

    });

})( jQuery );
